/*
// Licensed Materials - Property of HCL
// (C) Copyright HCL Technologies Limited 2001, 2020
// All Rights Reserved
*/
import React from 'react'
import { Tooltip } from '@patron/patron-react/tooltip'
import _ from '../../../services/utils/BfLodash'
import BfSplitTextInLines from '../../common/BfSplitTextInLines'

/**
 * Formats cell value with tooltip
 */

const BfCellWithTooltipRenderer = (props) => {
  const { noSplit, maxLine, maxChars } = props

  let textTooltip = props.textTooltip

  const maxLineSanitized = _.isUndefined(maxLine) || !_.isNumber(maxLine) ? -1 : maxLine

  if (_.isDefined(maxChars)) {
    textTooltip = _.truncate(textTooltip, {
      length: maxChars
    })
  }
  const content = _.isUndefined(noSplit) ? BfSplitTextInLines(textTooltip, maxLineSanitized) : textTooltip
  return (
    <Tooltip content={<div>{content}</div>} direction='bottom' type='definition'>
      {props.children}
    </Tooltip>
  )
}

export default BfCellWithTooltipRenderer
